import React from 'react';
import s from './style.module.css';

export interface Breadcrumb {
    name: string;
    url: string;
}
export type BreadcrumbProps = {
    breadcrumbList: Breadcrumb[];
    withoutBackground?: boolean;
};
export const Breadcrumb = (props: BreadcrumbProps) => {
    const withoutBackground = !!props.withoutBackground;

    return (
        <div className={`${s.breadcrumb} ${withoutBackground ? s.white : s.gray}`}>
            <div className={s.breadcrumb_inner}>
                {props.breadcrumbList.map((p, i) => (
                    <span key={i}>
                        {p.url ? <a href={p.url}>{p.name}</a> : p.name}
                        {i !== props.breadcrumbList.length - 1 ? '>' : ''}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Breadcrumb;
